import LogEventMessage from 'automation-ui-log-events/components/LogEventMessage';
import LogEventKeys from 'automation-ui-log-events/constants/LogEventKeys';
import { ExecutionStates } from 'automation-ui-log-events/constants/LogEventConstants';
import { jsx as _jsx } from "react/jsx-runtime";
const PartialSuccessMessage = ({
  executionResult,
  flowObjectTypeId,
  logEvent
}) => {
  const logEventWithExecutionResultData = logEvent.merge({
    [LogEventKeys.EXECUTION_STATE]: ExecutionStates.FAIL_CONTINUE,
    [LogEventKeys.ERROR_TYPE]: executionResult.getErrorType() || undefined,
    [LogEventKeys.ERROR_SUB_TYPE]: executionResult.getErrorSubType(),
    [LogEventKeys.IDEMPOTENCY_ID]: `${logEvent.idempotencyId}-${executionResult.hashCode()}`
  });
  return /*#__PURE__*/_jsx(LogEventMessage, {
    flowObjectTypeId: flowObjectTypeId,
    logEvent: logEventWithExecutionResultData
  });
};
export default PartialSuccessMessage;